import { render, staticRenderFns } from "./updTxts.vue?vue&type=template&id=cbee50d2"
import script from "./updTxts.vue?vue&type=script&lang=js"
export * from "./updTxts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports